
import { FaRegCircle, FaCircle } from 'react-icons/fa6';
import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { IoMdCheckboxOutline } from "react-icons/io";

type ToggleCellProps = {
    showValidations?: boolean;
    valid?: boolean;
    value?: boolean;
    type?: 'check' | 'circle';
    toggle?: (event: React.MouseEvent<HTMLTableCellElement>) => void;
    className?: string;
};

export default function ToggleCell(props: ToggleCellProps) {
    return (
        <td className={`checkbox${props.showValidations && !props.valid ? ' invalid' : ''}${props.value ? ' checked' : ''}${props.className ? ` ${props.className}` : ''}`} onClick={props.toggle} >
            {props.type === 'check' ?
                <>
                    {props.value?
                        <IoMdCheckboxOutline className="actionIcon" />:
                        <MdCheckBoxOutlineBlank className="actionIcon" />
                    }
                </>
                : <>
                    {props.value ?
                        <FaCircle className="actionIcon" />:
                        <FaRegCircle className="actionIcon" />
                    }
                </>
            }
        </td>
    );
}
